import classNames from 'classnames';
import React from 'react';
import FadeIn from 'react-fade-in';
import { createUseStyles } from 'react-jss';
import { QRCode } from '../qr-code';

function PixQRCode({
  className,
  analyticsFeatureUseEvent,
  // analyticsHollowEvent,
  payload,
  // onClick,
}) {
  const classes = useStyles();

  const handleClick = () => {
    analyticsFeatureUseEvent?.call(this, 'pix qrcode click');
    // onClick?.call(this);
  };

  return (
    <FadeIn>
      <div className={classNames(classes.container, className)}>
        <QRCode
          className={classes.qrCode}
          payload={payload}
          onClick={handleClick}
        />
      </div>
    </FadeIn>
  );
}

const useStyles = createUseStyles({
  container: {
    // cursor: 'pointer',
    // marginTop: layoutDefaults.verticalMargin,
    // marginBottom: layoutDefaults.smallVerticalMargin,
    // marginBottom: 20,
    // border: '1px solid white',
  },
  // instruction: {
  // color: '#3FC3EE',
  // fontSize: '1.1em',
  // textDecoration: 'none',
  // },
  qrCode: {
    // height: 10,
    // padding: 70,
  },
  // qrCodeContent: {},
  // qrCodeFooter: {
  // marginTop: 16,
  // marginBottom: 16,
  // },
});

export { PixQRCode };
